/* Product and course pages: when the chosen variant changes, re-render the dynamic region
   (price, availability, button) from the server via the Section Rendering API. */
(() => {
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const sectionId = root.dataset.sectionId;
    const url = root.dataset.productUrl;
    const variantsEl = root.querySelector('script[data-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : null;
    let controller;

    const currentVariantId = (target) => {
      // Course pages: the radio value is the variant id.
      if (target.name === 'id') return target.value;
      // Retail pages: match the chosen options against the variant list.
      if (!variants) return null;
      const chosen = [...root.querySelectorAll('input[data-option-index]:checked')]
        .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
        .map((el) => el.value);
      const match = variants.find((v) => v.options.every((value, i) => value === chosen[i]));
      return match ? match.id : null;
    };

    root.addEventListener('change', async (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !(target.name === 'id' || target.dataset.optionIndex)) return;
      const id = currentVariantId(target);
      const idField = root.querySelector('input[name="id"][type="hidden"]');
      if (id && idField) idField.value = id;
      if (!id) return;

      controller?.abort();
      controller = new AbortController();
      try {
        const res = await fetch(`${url}?variant=${id}&section_id=${sectionId}`, { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-product-dynamic]');
        const region = root.querySelector('[data-product-dynamic]');
        if (fresh && region) region.innerHTML = fresh.innerHTML;
        history.replaceState(null, '', `${url}?variant=${id}`);
      } catch (err) {
        if (err.name !== 'AbortError') console.error(err);
      }
    });
  });
})();
